import api from './api'

export type GetCollegeGuidanceNetworkIntegrationResponse = {
  Url: string
  ShowBanner: boolean
}

export type SetCollegeGuidanceNetworkIntegrationBody = {
  HideBanner: boolean
}

const getCollegeGuidanceNetworkIntegration = () =>
  api.get<GetCollegeGuidanceNetworkIntegrationResponse>('/api/college_guidance_network')

const setCollegeGuidanceNetworkIntegration = (body: SetCollegeGuidanceNetworkIntegrationBody) =>
  api.put<SetCollegeGuidanceNetworkIntegrationBody, void>('/api/college_guidance_network', body)

const getCollegeGuidanceNetworkService = {
  getCollegeGuidanceNetworkIntegration,
  setCollegeGuidanceNetworkIntegration,
}

export default getCollegeGuidanceNetworkService
